module.exports = __webpack_public_path__ + "static/media/p0201.adc54a43.jpg";